import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AdsService = {
  // Get all ads with pagination and filtering
  adsList: async ({
    searchText,
    adName,
    isActive,
    status,
    pageNumber = 1,
    pageSize = 10,
    adFormat,
    mediaType,
    tags,
    advertiserName,
    minFileSize,
    maxFileSize,
    durationSeconds,
    fromDate,
    toDate,
    recentlyUploaded,
  } = {}) => {
    const params = new URLSearchParams();

    // Support both searchText (legacy) and adName (new)
    const adNameValue = adName || searchText;
    if (adNameValue && adNameValue.trim())
      params.append("adName", adNameValue.trim());

    // Support both isActive (legacy) and status (new)
    if (status !== undefined && status !== "") params.append("status", status);
    else if (isActive !== undefined && isActive !== "")
      params.append("status", isActive);

    if (adFormat !== undefined) params.append("adFormat", adFormat);
    if (mediaType !== undefined) params.append("mediaType", mediaType);
    if (advertiserName && advertiserName.trim())
      params.append("advertiserName", advertiserName.trim());
    if (tags && Array.isArray(tags) && tags.length > 0) {
      tags.forEach((tag) => params.append("tags", tag));
    }
    // Convert KB to bytes for API (KB * 1024 = bytes)
    if (minFileSize !== undefined && minFileSize > 0)
      params.append("minFileSize", minFileSize * 1024);
    if (maxFileSize !== undefined && maxFileSize > 0)
      params.append("maxFileSize", maxFileSize * 1024);
    if (durationSeconds !== undefined)
      params.append("durationSeconds", durationSeconds);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (recentlyUploaded !== undefined)
      params.append("recentlyUploaded", recentlyUploaded);

    if (pageNumber) params.append("pageNumber", pageNumber);
    if (pageSize) params.append("pageSize", pageSize);

    const queryString = params.toString();
    console.log("API Query String:", queryString);
    if (fromDate || toDate) {
      console.log(
        "📅 AdsService - Date Range: fromDate =",
        fromDate,
        "| toDate =",
        toDate,
      );
    }

    const response = await apiService.get(`/itouch/ads?${queryString}`);
    console.log(
      "🎬 AdsService API Response - Total records:",
      response.data?.length || 0,
    );
    return response.data;
  },
  // Create a new ad
  create: async (data) => {
    try {
      const response = await apiService.post("/itouch/ads", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating ad:", error);
      throw error;
    }
  },

  // Get ad by id
  getAdById: async (id) => {
    try {
      const response = await apiService.get(`/itouch/ads/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad:", error);
      throw error;
    }
  },

  // Update an ad
  update: async (id, data) => {
    try {
      const response = await apiService.put(`/itouch/ads/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ad:", error);
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await apiService.delete(`/itouch/ads?adId=${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting ad:", error);
      throw error;
    }
  },
};

export default AdsService;
